import * as React from 'react';
import { Box } from '@chakra-ui/react';
import { AlertTriangle } from 'lucide-react';
import {
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

type Props = {
  title: string;
  children: React.ReactNode;
};

/**
 * Audit flag — an amber-bordered note calling out drift the audit
 * found (off-token colors, duplicated components, bypassed wrappers).
 * This is what makes the page an *audit* rather than a style guide.
 */
export const Callout = ({ title, children }: Props) => (
  <Box borderWidth="1px" borderColor="orange" bg="#FFF9EC" rounded="lg" p={4}>
    <HStack gap={2} align="flex-start">
      <Box mt="2px" flexShrink={0}>
        <AlertTriangle size={16} color="#B8860B" />
      </Box>
      <VStack gap={1} align="stretch">
        <Text fontSize="sm" fontWeight="bold" color="muted.900">
          {title}
        </Text>
        <Text fontSize="sm" color="muted.600">
          {children}
        </Text>
      </VStack>
    </HStack>
  </Box>
);
